import { useState, useEffect } from 'react';
import { PhoneDisplayTypeEnum } from '@commerce-profile-webcomponents/sdk';
import { parsePhoneNumber } from 'libphonenumber-js/min';
import { ConfigService, Logger } from '@nextgen-web-framework/core';
import logObject from '../../../../logObject';
import { iff } from '../../../utils/helper';
import { PhoneNumberDisplayProps } from './types/propTypes';
import styles from './PhoneNumberDisplay.module.scss';

const PhoneNumberDisplay = ({
  countryCode,
  phoneNumber,
  phoneDisplayFormat,
  className,
  preventBrowserDefaultStyles = true,
  ...props
}: PhoneNumberDisplayProps) => {
  const { PHONE_DISPLAY_FORMAT } = ConfigService.getConfigs();
  const configPhoneDisplayFormat = phoneDisplayFormat ?? PHONE_DISPLAY_FORMAT;

  const [phone, setPhone] = useState('');
  const logger = Logger.getInstance(logObject('PhoneNumberDisplay.tsx', 'PhoneNumberDisplay'));

  useEffect(() => {
    const formattedPhone = processPhoneNumber(`${countryCode ?? ''}${phoneNumber}`);
    setPhone(formattedPhone);
  }, [countryCode, phoneNumber]);

  const processPhoneNumber = (phoneStr: string) => {
    try {
      const numbers = parsePhoneNumber(phoneStr);
      return (configPhoneDisplayFormat as PhoneDisplayTypeEnum) === PhoneDisplayTypeEnum.INTERNATIONAL
        ? numbers?.formatInternational()
        : numbers?.formatNational();
    } catch (err) {
      logger.error('Error parsing phone number', err, countryCode, phoneNumber);
      // return original value if error
      return phoneStr;
    }
  };

  const additionalStyles = preventBrowserDefaultStyles
    ? {
        pointerEvents: 'none',
        textDecoration: 'none',
      }
    : {};

  return (
    <span
      className={`${iff(preventBrowserDefaultStyles, styles['phone-number-display'], '')} ${className}`}
      style={additionalStyles as React.CSSProperties}
      data-testid="phone-display-testid"
      {...props}
    >
      {phone}
    </span>
  );
};

export default PhoneNumberDisplay;
